var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcono(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.988,
    height: 18.988,
    viewBox: "0 0 18.988 18.988",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #000000;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3048",
    "data-name": "Path 3048",
    className: "cls-1",
    d: "M277.153,277.153V283H283v-5.843Zm0-1.461H283a1.461,1.461,0,0,1,1.461,1.461V283A1.461,1.461,0,0,1,283,284.456h-5.843A1.461,1.461,0,0,1,275.692,283v-5.843A1.461,1.461,0,0,1,277.153,275.692Zm0,11.685v5.843H283v-5.843Zm0-1.461H283a1.461,1.461,0,0,1,1.461,1.461v5.843A1.461,1.461,0,0,1,283,294.681h-5.843a1.461,1.461,0,0,1-1.461-1.461v-5.843A1.461,1.461,0,0,1,277.153,285.917Zm13.146-8.764a2.921,2.921,0,1,0,2.921,2.921A2.921,2.921,0,0,0,290.3,277.153Zm0-1.461a4.382,4.382,0,1,1-4.382,4.382A4.382,4.382,0,0,1,290.3,275.692Zm-2.921,11.685v5.843h5.843v-5.843Zm0-1.461h5.843a1.461,1.461,0,0,1,1.461,1.461v5.843a1.461,1.461,0,0,1-1.461,1.461h-5.843a1.461,1.461,0,0,1-1.461-1.461v-5.843A1.461,1.461,0,0,1,287.378,285.917Z",
    transform: "translate(-275.692 -275.692)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcono);
export default __webpack_public_path__ + "static/media/Icono.36d7addc46fec6436844883d19078929.svg";
export { ForwardRef as ReactComponent };